(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.KeyBoardOutputManager = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var PROCESS_TYPE = {
    NUMBER_STRING: '1001', // 有意义的数值字符串
    DIGITAL_STRING: '1002', // 无意义的数字字符串
    ID_CARD: '1003'
  };

  var KeyboardOutputManager = function () {
    function KeyboardOutputManager() {
      var processType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PROCESS_TYPE.NUMBER_STRING;

      _classCallCheck(this, KeyboardOutputManager);

      this.value = '';
      this.processType = processType;
    }

    _createClass(KeyboardOutputManager, [{
      key: 'handleAsNumberString',
      value: function handleAsNumberString(char) {
        if (/^\d$/.test(char)) {
          if (/^0$/.test(this.value) || /^00$/.test(this.value)) {
            this._set(char);
          } else {
            this._set(this.value + char);
          }
        } else if (/^\.$/.test(char)) {
          if (/^0$/.test(this.value)) {
            this._set('0.');
          }
          if (/^$/.test(this.value)) {
            this._set('0.');
          }
          if (!/\./.test(this.value)) {
            this._set(this.value + char);
          }
        } else if (/^#$/.test(char)) {
          this._set(this.value.slice(0, -1));
        } else if (/^00$/.test(char)) {
          if (/^0$/.test(this.value) || /^00$/.test(this.value)) {
            this._set(char);
          } else {
            this._set(this.value + char);
          }
        }
      }
    }, {
      key: 'handleAsDigitalString',
      value: function handleAsDigitalString(char) {
        if (/^\d$/.test(char)) {
          this._set(this.value + char);
        } else if (/^#$/.test(char)) {
          this._set(this.value.slice(0, -1));
        }
      }
    }, {
      key: 'handleAsIdString',
      value: function handleAsIdString(char) {
        if (this.value.length < 18) {
          if (/^X$/.test(char)) {
            if (this.value.length === 17) {
              this._set(this.value + char);
            }
          } else if (/^\d$/.test(char)) {
            this._set(this.value + char);
          } else if (/^#$/.test(char)) {
            this._set(this.value.slice(0, -1));
          }
        } else if (/^#$/.test(char)) {
          this._set(this.value.slice(0, -1));
        }
      }
    }, {
      key: 'handleInput',
      value: function handleInput(char) {
        switch (this.processType) {
          case PROCESS_TYPE.NUMBER_STRING:
            this.handleAsNumberString(char);
            break;
          case PROCESS_TYPE.DIGITAL_STRING:
            this.handleAsDigitalString(char);
            break;
          case PROCESS_TYPE.ID_CARD:
            this.handleAsIdString(char);
            break;
          default:
        }
      }
    }, {
      key: '_set',
      value: function _set(val) {
        this.value = val;
        if (typeof this.fn === 'function') this.fn(this.value);
      }
    }, {
      key: 'onUpdate',
      value: function onUpdate(fn) {
        this.fn = fn;
      }
    }, {
      key: 'setValue',
      value: function setValue(val) {
        var formatValue = Number(val);
        if (!isNaN(formatValue)) {
          this._set(val);
        } else {
          throw new Error('Invalid number.');
        }
      }
    }]);

    return KeyboardOutputManager;
  }();

  exports.default = KeyboardOutputManager;


  KeyboardOutputManager.PROCESS_TYPE = PROCESS_TYPE;
});